import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {PurchaseOrderReportData} from "./purchase-order-report.data";

@Injectable()
export class PurchaseOrderReportModel extends ReportModel<PurchaseOrderReportData> {
    constructor(injector: Injector) {
        super(injector, PurchaseOrderReportData)
    }
}
